"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _templateObject, _templateObject2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ValueText = _styledComponents["default"].label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-style: normal;\n  text-align: left;\n  font-size: ", ";\n  font-stretch: ", ";\n  font-weight: ", ";\n  align-items: center;\n  letter-spacing: ", ";\n  line-height: ", ";\n  outline: none;\n  color: ", ";\n  cursor: ", ";\n  ", "\n  overflow-wrap: anywhere;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontStretch;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.letterSpacing;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontColor;
}, function (_ref7) {
  var htmlFor = _ref7.htmlFor,
    isDisabled = _ref7.isDisabled;
  return isDisabled || !htmlFor ? 'default' : 'pointer';
}, (0, _polished.ellipsis)(), function (_ref8) {
  var isRequired = _ref8.isRequired,
    theme = _ref8.theme;
  return isRequired && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", " {\n        content: ", ";\n        color: ", ";\n      }\n    "])), theme.iconSet === 'novo' ? '&::after' : '&::before', theme.iconSet === 'novo' ? '" *"' : '"* "', theme.fontColorStarRequired);
});
var _default = ValueText;
exports["default"] = _default;